import api from './AxiosService';

const WinnerService = {
  getAllWinners: () => api.get('/winner?refresh=true'),
  getWinnersByContest: (contestId) => api.get(`/winner/contest/${contestId}`),
  getCandidates: (contestId) => api.get(`/winner/contest/${contestId}/candidates`),
  declareWinner: (data) => api.post('/winner', data),
  declareWinnersBulk: (data) => api.post('/winner/declare', data),
  deleteWinner: (winnerId) => api.delete(`/winner/${winnerId}`),
};

export default WinnerService;
